import { SET_USER_TYPE } from '../actions/ads';
import { SET_PROPS } from '../actions/ads';


const initialState = {
    userType: null,
    props: {}
};

function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_USER_TYPE:
            return {
                ...state,
                userType: action.payload,
            };         
        case SET_PROPS:
            return {
                ...state,
                props: action.payload,
            }
        default:
            return state;
    }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/ads.js